import { Link } from "react-router-dom"
import { dateFormat, dateFormatTime } from '../helper/DateHelper'
import { getBoartStatus } from '../helper/PostStatusHelper'
import { getBrand, getModel } from '../helper/BrandAirHelper'
import { useState } from "react"
import { db } from "../../assets/js/firebase"

const PostCard = ({post}) => {
    const number_format = new Intl.NumberFormat()
    const status = getBoartStatus('air', post.data.status, 'admin')

    const [air1Brand, setAir1Brand] = useState('ไม่ระบุ')
    const [air2Brand, setAir2Brand] = useState('ไม่ระบุ')
    const [air3Brand, setAir3Brand] = useState('ไม่ระบุ')

    const [air1Model, setAir1Model] = useState('ไม่ระบุ')
    const [air2Model, setAir2Model] = useState('ไม่ระบุ')
    const [air3Model, setAir3Model] = useState('ไม่ระบุ')

    getBrand(db, post.data.air1_brand_id, post.data.air1_brand).then((brandName) => {
        setAir1Brand(brandName)
    })
    getBrand(db, post.data.air2_brand_id, post.data.air2_brand).then((brandName) => {
        setAir2Brand(brandName)
    })
    getBrand(db, post.data.air3_brand_id, post.data.air3_brand).then((brandName) => {
        setAir3Brand(brandName)
    })

    getModel(db, post.data.air1_model_id, post.data.air1_model).then((modelName) => {
        setAir1Model(modelName)
    })
    getModel(db, post.data.air2_model_id, post.data.air2_model).then((modelName) => {
        setAir2Model(modelName)
    })
    getModel(db, post.data.air3_model_id, post.data.air3_model).then((modelName) => {
        setAir3Model(modelName)
    })

    return (
        <div style={{ display: 'flex', flexDirection: 'column', flex: 1 }} key={post.id}>
            <Link className="btn btn-white" to={`/admin/clean/detail/1/${post.id}`} style={{ display: 'flex', flex: 1 }}>
                <div className="card" style={{ width: "16rem", alignItems:'center', display: 'flex', flex: 1 }}>
                    {(post.data.status==1) && 
                        (<div className="float-right" style={{ position:'absolute', float: 'right', display:'flex', alignSelf: 'end', marginTop: 5, marginRight: 5}} >
                            <button type="button" className="btn btn-primary" style={{ color: '#ffffff'}}>
                                <strong>สถานะ:</strong> {status}
                            </button>
                        </div>)
                    }
                    {(post.data.status==2) && 
                        (<div className="float-right" style={{ position:'absolute', float: 'right', display:'flex', alignSelf: 'end', marginTop: 5, marginRight: 5}} >
                            <button type="button" className="btn btn-primary">
                                <strong>สถานะ:</strong> {status} <span className="badge badge-light" style={{ backgroundColor: '#ff0000'}}>{post.offer.length}</span>
                            </button>
                        </div>)
                    }
                    {(post.data.status==3) && 
                        (<div className="float-right" style={{ position:'absolute', float: 'right', display:'flex', alignSelf: 'end', marginTop: 5, marginRight: 5}} >
                            <button type="button" className="btn btn-warning" style={{ color: '#000000'}}>
                                <strong>สถานะ:</strong> {status}
                            </button>
                        </div>)
                    }
                    {(post.data.status==4) && 
                        (<div className="float-right" style={{ position:'absolute', float: 'right', display:'flex', alignSelf: 'end', marginTop: 5, marginRight: 5}} >
                            <button type="button" className="btn btn-success" style={{ color: '#ffffff'}}>
                                <strong>สถานะ:</strong> {status}
                            </button>
                        </div>)
                    }
                    {(post.data.status==5) &&
                        (<div className="float-right" style={{ position:'absolute', float: 'right', display:'flex', alignSelf: 'end', marginTop: 5, marginRight: 5}} >
                            <button type="button" className="btn btn-danger" style={{ color: '#FFFFFF'}}>
                                <strong>สถานะ:</strong> {status}
                            </button>
                        </div>)
                    }
                    {(post.data.status==6) && 
                        (<div className="float-right" style={{ position:'absolute', float: 'right', display:'flex', alignSelf: 'end', marginTop: 5, marginRight: 5}} >
                            <button type="button" className="btn btn-danger" style={{ color: '#ffffff'}}>
                                <strong>สถานะ:</strong> {status}
                            </button>
                        </div>)
                    }
                    {(post.data.status==9) && 
                        (<div className="float-right" style={{ position:'absolute', float: 'right', display:'flex', alignSelf: 'end', marginTop: 5, marginRight: 5}} >
                            <button type="button" className="btn btn-success" style={{ color: '#ffffff'}}>
                                <strong>สถานะ:</strong> {status}
                            </button>
                        </div>)
                    }
                    <div style={{ marginLeft: 20, marginRight: 20, marginTop: 20, display: 'flex', alignContent: 'center', textAlign:'center' }} >
                        <img src={post.data.picture} alt="WEEE" height="150" />
                    </div>
                    <div className="card-body" style={{ display: 'flex', flex: 1, alignSelf: 'start', alignItems: 'start', flexDirection:'column'}} >
                        <div className="card-text" style={{ textAlign: 'left' }}>
                            {(post.data.have_air1) && 
                            <>
                            <font style={{ fontSize: 17 }}><strong>บริการติดตั้งแอร์ผนัง</strong><br/></font>
                            <font style={{ fontSize: 17 }}><strong>{air1Brand} {air1Model}</strong><br/></font>
                            <font style={{ marginLeft: 10 }}>ขนาด: {number_format.format(post.data.air1_BTU)} BTU<br/></font>
                            <font style={{ marginLeft: 10 }}>จำนวน: {number_format.format(post.data.air1_amount)} เครื่อง<br/></font>
                            </>
                            }
                            {(post.data.have_air2) && 
                            <>
                            <font style={{ fontSize: 17 }}><strong>บริการล้างแอร์แขวนใต้ฝ้า</strong><br/></font>
                            <font style={{ fontSize: 17 }}><strong>{air2Brand} {air2Model}</strong><br/></font>
                            <font style={{ marginLeft: 10 }}>ขนาด: {number_format.format(post.data.air2_BTU)} BTU<br/></font>
                            <font style={{ marginLeft: 10 }}>จำนวน: {number_format.format(post.data.air2_amount)} เครื่อง<br/></font>
                            </>
                            }
                            {(post.data.have_air3) && 
                            <>
                            <font style={{ fontSize: 17 }}><strong>บริการล้างแอร์ฝังฝ้า 4 ทิศทาง</strong><br/></font>
                            <font style={{ fontSize: 17 }}><strong>{air3Brand} {air3Model}</strong><br/></font>
                            <font style={{ marginLeft: 10 }}>ขนาด: {number_format.format(post.data.air3_BTU)} BTU<br/></font>
                            <font style={{ marginLeft: 10 }}>จำนวน: {number_format.format(post.data.air3_amount)} เครื่อง<br/></font>
                            </>
                            }
                        </div>
                        <div className="card-text" style={{ textAlign: 'left' }}><strong>ผู้ประกาศ :</strong> {post.poster.data().firstname} {post.poster.data().lastname}</div> 
                        <div className="card-text" style={{ textAlign: 'left' }}><strong>วันที่ลงประกาศ:</strong><br/>{dateFormatTime(post.data.post_timestamp)}</div>
                    </div>
                </div>
            </Link>
        </div>
    )
} 

export default PostCard